<template>
  <div class="loader">
    <div class="stage">
      <div class="dot-pulse"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vch-loader',
};
</script>

<style lang="scss" src="./loader.scss"></style>
